import React, { useContext } from 'react';
import { ThemeContext } from '../context/theme-context';
import styles from '../styles/ThemeSwitcher.module.css';
import { FaMoon, FaSun } from 'react-icons/fa';

function ThemeSwitcher() {
    const { theme, toggleTheme } = useContext(ThemeContext);

    return (
        <button
            className={styles.themeSwitcher}
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
            {theme === 'light' ? <FaMoon /> : <FaSun />}
        </button>
    );
}

export default ThemeSwitcher;